import { faEye, faEyeSlash, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRef, useState } from 'react';

import useTranslate from '@/hooks/useTranslate';
import { UI_COMPONENTS_MEMBERS_FORM_PATH_TRANSLATION_KEY } from '@/ui/members/components/form/constants';
import Input from '@/ui/members/components/form/Input/Input';
import { focusClasses } from '@/ui/members/components/form/styles';

import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const PasswordInput = ({
  autoFocus = false,
  label = 'Password',
  onChange,
  placeholder = 'Enter a password',
  value
}: Props) => {
  const [visible, setVisible] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslate(`${UI_COMPONENTS_MEMBERS_FORM_PATH_TRANSLATION_KEY}.PasswordInput`);
  const hasTyped = value?.length && value.length > 0;

  // Validation checks
  const isAtLeast8 = hasTyped && value.length >= 8;
  const hasNoSpaces = hasTyped && !/\s/.test(value);

  const toggleVisibility = () => {
    const input = inputRef.current;
    if (!input) return;

    const { selectionStart, selectionEnd } = input;
    setVisible((v) => !v);

    setTimeout(() => {
      input.focus();
      input.setSelectionRange(selectionStart ?? 0, selectionEnd ?? 0);
    }, 0);
  };

  return (
    <div>
      <Input
        autoFocus={autoFocus}
        ref={inputRef}
        autoComplete="password"
        id="password"
        inputClassName="relative pr-10"
        label={label}
        onChange={onChange}
        placeholder={placeholder}
        type={visible ? 'text' : 'password'}
        value={value}>
        <button
          type="button"
          onClick={toggleVisibility}
          onMouseDown={(e) => e.preventDefault()}
          aria-label={visible ? t('hidePassword') : t('showPassword')}
          className={`absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 ${focusClasses}`}>
          <FontAwesomeIcon icon={visible ? faEyeSlash : faEye} />
        </button>
      </Input>

      {/* Validation list */}
      <ul className="mt-2 space-y-1 text-base dark:text-uniform-gray-300 light:text-uniform-gray-600">
        <li className="flex items-center">
          <FontAwesomeIcon
            icon={faCheckCircle}
            className={`mr-2 ${isAtLeast8 ? 'text-uniform-green-500' : ''}`}
          />
          {t('atLeast8Characters')}
        </li>

        <li className="flex items-center">
          <FontAwesomeIcon
            icon={faCheckCircle}
            className={`mr-2 ${hasNoSpaces ? 'text-uniform-green-500' : ''}`}
          />
          {t('noSpaces')}
        </li>
      </ul>
    </div>
  );
};

export default PasswordInput;
